import React from 'react'
import { connect } from 'react-redux'
import api from '../../../../../services/api'
import { PlusOutlined } from '@ant-design/icons'
import { Radio, Input, Upload, message, Popover, Form } from 'antd'
import { setCommonConfig } from '../../../../../store/actions/index'
import ColorPicker from '../../../../../components/ColorPicker'
import unit from '../../../../../utils/utils'
import { useTranslation } from 'react-i18next'
import { getAuthHeaders } from '@/utils/session'
const FormItem = Form.Item
const formItemLayout = {
  labelCol: {
    span: 6,
  },
  wrapperCol: {
    span: 14,
  },
}
const mapDispatchToProps = dispatch => ({
  editConfig: (id, name, value) => {
    dispatch(setCommonConfig(id, name, value))
  },
})
const mapStateToProps = state => ({
  domain: state.tree.root.config.domain,
})
const CustomTitle = props => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { editConfig, id, pid, config } = props
  const { t } = useTranslation()
  const setConfig = (name, value) => {
    editConfig(id, name, value)
  }
  const uploadProps = {
    className: 'avatar-uploader',
    name: 'content',
    action: api.uploadImg,
    showUploadList: false,
    data: {
      format: 'jpg',
      fulldim: '300x300',
      path: 'a.jpg',
    },
    headers: getAuthHeaders() as Record<string, string>,
    beforeUpload: file => {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      if (!isJPG) {
        message.error('You can only upload JPG/PNG file!')
      }
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        message.error('Image must smaller than 2MB!')
      }
      uploadProps.data.path = `${unit.generateImgName()}.${file.name}`
      return isJPG && isLt2M
    },
  }
  const uploadImg = e => {
    const fileStatus = e.file
    const basePath = api.baleenUrl
    if (fileStatus.status === 'done') {
      const imgPath = fileStatus.response.name
      setConfig('titleIcon', `${basePath}/${imgPath}`)
    }
  }
  const content = (
    <ColorPicker
      handleOk={color => setConfig('bgColor', color)}
      color={config && config.bgColor}
    ></ColorPicker>
  )
  return (
    <div className="form-box">
      <Form>
        <FormItem {...formItemLayout} label={t('titleType')}>
          <Radio.Group
            onChange={e => setConfig('titleType', e.target.value)}
            value={(config && config.titleType) || 'imgTitle'}
          >
            <Radio value={'imgTitle'}>{t('normal')}</Radio>
            <Radio value={'btnTitle'}>{t('block')}</Radio>
          </Radio.Group>
        </FormItem>
        <FormItem {...formItemLayout} label={t('text')}>
          <Input
            className="input-lar-input"
            type="text"
            placeholder={t('text')}
            value={config && config.title}
            onChange={e => setConfig('title', e.target.value)}
          />
        </FormItem>
        <FormItem {...formItemLayout} label={t('fontColor')}>
          <Radio.Group
            onChange={e => setConfig('textClor', e.target.value)}
            value={(config && config.textClor) || 'light'}
          >
            <Radio value={'light'}>{t('white')}</Radio>
            <Radio value={'black'}>{t('black')}</Radio>
          </Radio.Group>
        </FormItem>
        {config.titleType === 'btnTitle' ? (
          <>
            <FormItem {...formItemLayout} label={t('readMoreButtonText')}>
              <Input
                className="input-lar-input"
                type="text"
                placeholder="马上查看"
                value={config && config.rightText}
                onChange={e => setConfig('rightText', e.target.value)}
              />
            </FormItem>
            <FormItem {...formItemLayout} label="link">
              <Input
                className="input-lar-input"
                type="text"
                placeholder="link"
                value={config && config.link}
                onChange={e => setConfig('link', e.target.value)}
              />
            </FormItem>
            <FormItem {...formItemLayout} label="deeplink">
              <Input
                className="input-lar-input"
                type="text"
                placeholder="deeplink"
                value={config && config.deeplink}
                onChange={e => setConfig('deeplink', e.target.value)}
              />
            </FormItem>
            <FormItem {...formItemLayout} label={t('backgroundColor')}>
              <Popover
                placement="right"
                title={t('backgroundColor')}
                content={content}
                trigger="click"
              >
                <div
                  className="colorBtn"
                  style={{
                    backgroundColor: (config && config.bgColor) || 'rgba(0,0,0,0.7)',
                  }}
                ></div>
              </Popover>
            </FormItem>
          </>
        ) : (
          <FormItem {...formItemLayout} label={t('icons')}>
            <Upload {...uploadProps} onChange={uploadImg}>
              {config && config.titleIcon ? (
                <img src={config && config.titleIcon} alt="" className="avatar shareImg" />
              ) : (
                <PlusOutlined className="avatar-uploader-trigger" />
              )}
            </Upload>
          </FormItem>
        )}
      </Form>
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomTitle)
